import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import EditApproverApi from "../../../api/approvals/EditApproverApi";
import { GetApproversApi } from "../../../api/approvals/GetApproversApi";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../../helpers/NotificationHelpers";

const { Option } = Select;

function EditApproverModal(props) {
  const [submit, setSubmit] = useState(false);
  const positionState = useSelector((state) => state.positionState.value);
  const [approvers, setApprovers] = useState([]);
  const [valuesChanged, setValuesChanged] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    getApprovers();
  }, []);

  function handleCancel() {
    setSubmit(false);
    setValuesChanged(false);
    props.handleCancel();
    form.resetFields();
  }

  async function onFinish(value) {
    setSubmit(true);
    const apiResponse = await EditApproverApi(props.data, value.name);
    if (apiResponse.error) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.success) {
      openNotificationSuccess("bottomRight", "Approver edited successfully");
      props.handleOk();
    } else {
      openNotificationError(
        "bottomRight",
        "Couldn't edit approver. Try again later."
      );
    }
    handleCancel();
  }
  async function getApprovers() {
    const apiResponse = await GetApproversApi(positionState?.id);

    if (apiResponse.error) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.success) {
      setApprovers(apiResponse?.data);
      form.setFields([
        {
          name: "name",
          value: props.currentApprover,
        },
      ]);
    } else {
      openNotificationError(
        "bottomRight",
        "Couldn't edit approver. Try again later."
      );
    }
  }

  return (
    <Modal
      title="Edit approver name"
      visible={props.visible}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="planGroup"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        onValuesChange={() => {
          setValuesChanged(true);
        }}
        form={form}
      >
        <Form.Item label="Approver: " name="name">
          <Select
            allowClear
            showSearch
            placeholder="Select approver"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            filterSort={(optionA, optionB) =>
              optionA.children
                .toLowerCase()
                .localeCompare(optionB.children.toLowerCase())
            }
          >
            {approvers?.map((approver) => {
              return (
                <Option key={approver?.id} value={approver?.id}>
                  {(approver?.designations?.abbreviation ||
                    approver?.designations?.name) +
                    "," +
                    approver?.units?.name}
                </Option>
              );
            })}
          </Select>
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3 w-28" onClick={() => handleCancel()}>
              Cancel
            </Button>
            <Button
              className="btn w-28"
              type="primary"
              htmlType={submit && "submit"}
              disabled={submit || !valuesChanged}
            >
              {submit ? (
                <Spin
                  size="small"
                  indicator={<LoadingOutlined style={{ color: "#fff" }} spin />}
                />
              ) : (
                "Save"
              )}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}
export default EditApproverModal;
